import { createContext } from 'react';

import { ModalProviderProps } from '@/types/providers';

export const ModalContext = createContext<ModalProviderProps>({} as ModalProviderProps);
